// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___dd055b1d1a5fdf75bdd","cls2":"SimplePaperPodcast-cls2__c7b9fd7a6acbcbf91872 SimplePaperPodcast-cls1___dd055b1d1a5fdf75bdd"};